<template>
  <div></div>
</template>

<script>
/* eslint-disable */
import api from '@/pages/uc-web/api/api';
import { isApp, jsBridgeForSSAI } from '@/utils/index';
export default {
  data() {
    return {
      params:this.$route.query || {}
    }
  },
  mounted() {
    this.tokenLogin()
  },
  methods: {
    // 提交登录
    async tokenLogin() {
      const res = await api.getOpenJumpLink(this.params);
      localStorage.setItem('BigLoginParams', JSON.stringify(this.params))
      if(res.data.url){
        if (isApp()) {
          jsBridgeForSSAI('setData', {
            key: 'loginType',
            value: 1,
          })
        }
        window.location.href = res.data.url
      } else {
        if (isApp()) {
          jsBridgeForSSAI('loginFailure');
          return
        }
      }
    },
  },
};
</script>

<style>

</style>
